import { computed, Directive, HostBinding, Input, Signal, signal } from '@angular/core';
import { Validators } from '@angular/forms';
import { cva, type VariantProps } from 'class-variance-authority';

import { FormFieldControl } from '../form-field/form-field-control';

export const labelVariants = cva('tt-label', {
  variants: {
    error: {
      true: 'tt-label--error',
    },
    disabled: {
      true: 'tt-label--disabled',
    },
    required: {
      true: 'tt-label--required',
    },
  },
});
export type LabelVariants = VariantProps<typeof labelVariants>;

let nextId = 0;

@Directive({
  selector: '[ttLabel]',
  standalone: true,
})
export class LabelDirective {
  protected readonly _id = signal(`tt-label-${nextId++}`);

  protected control: FormFieldControl = null;

  @Input()
  set id(id: string) {
    this._id.set(id || this._id());
  }

  @HostBinding('class') get computedClass() {
    return this._computedClass();
  }

  private isRequired = signal(false);
  private error: Signal<boolean> = signal(false);
  private disabled = signal(false);

  protected readonly _computedClass = computed(() =>
    labelVariants({
      error: this.error(),
      disabled: this.disabled(),
      required: this.isRequired(),
    }),
  );

  public registerControl(control: FormFieldControl) {
    if (!control) {
      throw new Error('A tt-label must be associated with a control.');
    }

    if (this.control) {
      throw new Error('A tt-label can only be associated with a single control.');
    }

    this.control = control;
    this.isRequired.set(control?.ngControl?.control.hasValidator(Validators.required));
    this.error = control.errorState;
  }
}
